import { general } from './general'
import { list } from './list'
import { quote } from './quote'
import { motor } from './motor'
import { cargo } from './cargo'
import { fire } from './fire'
import { maid } from './maid'
import { travel } from './travel'
import { pa } from './pa'
import { pkg } from './package'
import { post } from './post'
import { updateStatus } from './updateStatus'

export const actions = Object.assign({}, general, list, quote, motor, cargo, fire, maid, travel, pa, pkg, post, updateStatus)
